import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import Plural from 'components/utils/Formatters/Plural'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { daysUntilDate } from 'lib/datetime/dateUtils'
import { getThemeClassName } from 'lib/theme/themeUtils'
import FormatLoyaltyBonusPoints from 'loyalty/components/Formatters/FormatLoyaltyBonusPoints'
import FormatLoyaltyStatusCredits from 'loyalty/components/Formatters/FormatLoyaltyStatusCredits'
import { LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS, LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS } from 'loyalty/constants/loyaltyBonusPoints'
import getIsLoyaltyLuxPlusRenewalBonusEnabled from 'loyalty/selectors/getIsLoyaltyLuxPlusRenewalBonusEnabled'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { getIsPendingRenewalLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import React, { useCallback } from 'react'
import * as Analytics from 'analytics/analytics'
import BodyText from 'LuxKit/Typography/BodyText'
import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'
import TextButton from 'LuxKit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import purchaseLuxPlus from 'actions/luxPlus/purchaseLuxPlus'

/**
 * @NOTE LuxKit Gods I am sorry for I have sinned. I have created this in the absence of the MessageBanner component
 * having an option to have a vertical direction for its actions. I will refactor / delete this if that gets added or at
 * the end of the LuxPlus+ month campaign takeover.
 *
 * It's a duplicate of the LuxPlusRenewalMessageBanner component.
 */
function LuxPlusRenewalWarningSheet() {
  const isLoyaltyLuxPlusRenewalBonusEnabled = useAppSelector(getIsLoyaltyLuxPlusRenewalBonusEnabled)
  const isPendingRenewalLuxPlusMember = useAppSelector(getIsPendingRenewalLuxPlusMember)
  const subscriptionItem = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item)
  const renewalStatus = subscriptionItem?.renewalStatus
  const dispatch = useAppDispatch()

  const handleRenewal = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'manual_renewal_purchase',
      action: 'add_to_cart_lux_plus_standalone',
      category: LUXURY_PLUS.ANALYTICS_CATEGORY,
      type: 'interaction',
    })
    dispatch(purchaseLuxPlus({ hasJoinFee: false }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (
    !subscriptionItem ||
    !isPendingRenewalLuxPlusMember ||
    renewalStatus !== 'ALLOW_RENEWAL' ||
    subscriptionItem.nextChargeAttemptDate === undefined
  ) return null

  const daysUntilNextChargeAttempt = daysUntilDate(new Date(subscriptionItem.nextChargeAttemptDate))

  return <Sheet
    background="critical-light"
    padding={16}
    className={getThemeClassName({ mobile: 'default' })}
  >
    <VerticalSpacer gap={16}>
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">Your payment was declined</BodyText>
        <BodyText variant="medium">
          Your benefits are on hold. We'll try to process the payment again{' '}
          {daysUntilNextChargeAttempt === 0 && <>on <FormatDateTime value={subscriptionItem.nextChargeAttemptDate} format="dmy-casual" />.</>}
          {daysUntilNextChargeAttempt > 0 && <>in <Plural count={daysUntilNextChargeAttempt} singular="day" withCount />.</>}
          {' '}
          {isLoyaltyLuxPlusRenewalBonusEnabled && <>
            Renew now to receive your
            {' '}
            <b><FormatLoyaltyStatusCredits statusCredits={LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS} /> & <FormatLoyaltyBonusPoints points={LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS} /></b>
            {' '}
            with {getLoyaltyProgramDisplayName()} and continue enjoying {LUXURY_PLUS.PROGRAM_NAME} pricing, bonus inclusions, early access & more.
          </>}
          {!isLoyaltyLuxPlusRenewalBonusEnabled && <>
            Renew now to continue enjoying {LUXURY_PLUS.PROGRAM_NAME} pricing, bonus inclusions, early access & more.
          </>}
        </BodyText>
      </VerticalSpacer>
      <Group direction="horizontal" gap={8}>
        <TextButton kind="tertiary" to={`/${LUXURY_PLUS_PATHS.ACCOUNT_MANAGEMENT_PAGE}`}>
          Manage membership
        </TextButton>
        <TextButton kind="secondary" onClick={handleRenewal}>
          Renew now
        </TextButton>
      </Group>
    </VerticalSpacer>
  </Sheet>
}

export default LuxPlusRenewalWarningSheet
